import { render, staticRenderFns } from "./cancelDialog.vue?vue&type=template&id=36b2bf9a&scoped=true"
import script from "./cancelDialog.vue?vue&type=script&lang=js"
export * from "./cancelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2bf9a",
  null
  
)

export default component.exports